var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},_vm._l((_vm.info),function(message,key){return (_vm.info.length > 0)?_c('div',{key:key,staticClass:"alert alert-info"},[_c('fa-icon',{staticClass:"w-6 h-6 mr-2",attrs:{"icon":['fas', 'exclamation']}}),_vm._v(" "+_vm._s(message)+" ")],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }